import { NumberService } from '@phone-number/services/NumberService';

import { createStore } from 'vuex-async-paginate';
import { TOTAL_ITEMS, SORT_COLUMN, SORT_DIRECTION } from 'vuex-async-paginate/src/const';

export const buy = createStore(
  {
    actions: {
      getData: (_, { country, type, region }) => {
        return NumberService.getBuyList(country, type, region);
      }
    },

    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    }
  },
  true,
  {
    [TOTAL_ITEMS]: 'total'
  }
);
